import React, { useCallback } from 'react';
import { useRouter } from 'expo-router';

import { GiftCard } from '@order/features-gift-card';
import { useTelemetry } from '@order/Telemetry';

import { useGiftCardContent } from '../../../../../hooks/useGiftCardContent';

// ─────────────────────────────────────────────────────────────────────────────

export const AccountMenuGiftCardHeader = () => {
  const router = useRouter();

  const { track } = useTelemetry();
  const contentfulData = useGiftCardContent();

  // ─── Handlers ──────────────────────────────────────────────────────────────

  const handlePress = useCallback(() => {
    track('account_gift_content_selected');

    router.navigate({ pathname: '/account/gift' });
  }, [router, track]);

  // ─────────────────────────────────────────────────────────────────────

  return <GiftCard.Account.Header {...contentfulData} onPress={handlePress} />;
};
